module.exports = __webpack_public_path__ + "static/media/clap-808.39f9581a.wav";